/**
 * @author Bertrand Chevrier <bertrand@taotesting.com>
 */
define('controller/users/disable-edit',['layout/section'], function(section) {
    'use strict';
       
    /**
     * Ensure edit section is disabled
     * @exports controller/users/disable-edit
     */    
    return {
        start : function(){
            section.get('edit_user').disable();
        }
    };
});

